import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

export function useDeleteOccasion(relationshipId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (occasionId: string) => {
      await api.delete(
        `relationships/${relationshipId}/occasions/${occasionId}`,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.relationship.byId(relationshipId),
      });
    },
  });
}
